import qs from 'qs';
import Auth from './auth';

export class Event {
  uKey;
  severityUkey;
  title;
  template;
  comment;

  constructor(
    uKey,
    severityUkey,
    title,
    template,
    comment
  ) {
    this.uKey = uKey;
    this.severityUkey = severityUkey;
    this.title = title;
    this.template = template;
    this.comment = comment;
  }
}

export class Severity {
  uKey;
  title;

  constructor(
    uKey,
    title
  ) {
    this.uKey = uKey;
    this.title = title;
  }
}

const Logging = {
  namespaced: true,

  state: {
  },

  getters: {
    adminName() {
      return this.$store.getters['auth/adminFullname'];
    },
    laServiceBasePath() {
      return this.$store.state.laUrl;
    },
  },

  /*mounted() {
    if (localStorage.getItem('username') == null || !localStorage.getItem('fullname') == null || !localStorage.getItem('email') == null) {
      Auth.actions.logout();
      return false;
    }
  },*/

  methods: {
    getLaServiceBasePath() {
      return this.$store.state.laUrl;
    },
  },

  actions: {

    prepareRawLogData(event, username, data) {
      return JSON.stringify({
        "severityUkey": event.severityUkey,
        "projectUkey": this.PROJECT_UKEY,
        "eventUkey": event.uKey,
        "username": username,
        "payload": this.rawStringReplace(event.template, data),
        "comment": this.rawStringReplace(event.comment, data),
        "ordering": 0,
        "status": 1
      });
    },

    rawStringReplace(haystack, data) {

    },

    async commitLogData({ commit, dispatch, getters, rootGetters }, { eventKey, username, payload, comment }) {
      const DEFAULT_LOG_STATUS = true;
      const PROJECT_UKEY = "POH_ADMIN";

      let url = rootGetters.laUrl;

      console.debug('Params: ', rootGetters, arguments[1]);

      let severities = {
        "TRACE": new Severity("TRACE", "Отслеживание"),
        "DEBUG": new Severity("DEBUG", "Отладка"),
        "INFO": new Severity("INFO", "Информация"),
        "WARN": new Severity("WARN", "Предупреждение"),
        "ERROR": new Severity("ERROR", "Ошибка"),
        "FATAL": new Severity("FATAL", "Критическая ошибка")
      };

      let events = {
        "101": new Event("101", severities.FATAL.uKey, "Неудачная попытка авторизации", ""),
        "201": new Event("201", severities.INFO.uKey, "Добавление пользователя", ""),
        "202": new Event("202", severities.INFO.uKey, "Добавление стоматолога", ""),
        "203": new Event("203", severities.INFO.uKey, "Добавление клиники", ""),
        "204": new Event("204", severities.INFO.uKey, "Удаление пользователя", ""),
        "205": new Event("205", severities.INFO.uKey, "Деактивация пользователя", ""),
        "206": new Event("206", severities.INFO.uKey, "Деактивация стоматолога", ""),
        "207": new Event("207", severities.INFO.uKey, "Деактивация клиники", ""),
        "208": new Event("208", severities.INFO.uKey, "Активация пользователя", ""),
        "209": new Event("209", severities.INFO.uKey, "Редактирование пользователя: прочие настройки", ""),
        "210": new Event("210", severities.INFO.uKey, "Редактирование стоматолога", "", ""),
        "211": new Event("211", severities.INFO.uKey, "Редактирование клиники", ""),
        "212": new Event("212", severities.INFO.uKey, "Удачная авторизация", ""),
        "214": new Event("214", severities.INFO.uKey, "Активация стоматолога", ""),
        "215": new Event("215", severities.INFO.uKey, "Активация клиники", ""),
        "301": new Event("301", severities.INFO.uKey, "Редактирование пользователя: назначена админская роль", ""),
        "302": new Event("302", severities.INFO.uKey, "Редактирование роли: изменение набора ролей", ""),
      };

      let headerUsername = 'admin',
        headerPassword = 'dcv#5s_H5W';
      const headers = new Headers();

      headers.set('Authorization', 'Basic ' + btoa(headerUsername + ":" + headerPassword));
      headers.append("Content-Type", "application/json");

      let event = events[eventKey];

      if (typeof event.severityUkey == 'undefined' || (!username || typeof username == 'undefined') || (!payload || typeof payload == 'undefined')) {
        return false;
      }

      const raw = JSON.stringify({
        "severityUkey": event.severityUkey,
        "projectUkey": PROJECT_UKEY,
        "eventUkey": event.uKey,
        "username": username.trim().replace(/\s\s+/g, ' '),
        "payload": typeof payload != 'undefined' ? payload.trim().replace(/\s\s+/g, ' ') : null,
        "comment": typeof comment != 'undefined' ? comment.trim().replace(/\s\s+/g, ' ') : null,
        "ordering": 0,
        "status": 1
      });

      const requestOptions = {
        method: "POST",
        headers: headers,
        body: raw,
        redirect: "follow"
      };

      await fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.error(error));
    },

    getChangedFields(oldAttributes, newAttributes) {
      let result = '';

      Object.keys(newAttributes).forEach((item, index) => {
        if (newAttributes[item] != oldAttributes[item] && item != 'staffIdChange' && item != 'extId') {
          result += item + ': ' + newAttributes[item] + '; ';
        }
      })

      console.warn(result);

      return result;
    },

    getRoles(oldAttributes, newAttributes) {
      let count = 0;
      Object.keys(newAttributes).forEach((item, index) => {
        if (newAttributes[item] != oldAttributes[item]) {
          count++;
        }
      });

      if (count == 0) { return '' }

      let result = '';
      let tempA = '';

      Object.keys(newAttributes).forEach((item, index) => {
        if ((item == 'isCustomer' || item == 'isTest' || item == 'isManager') && newAttributes[item] != oldAttributes[item] && newAttributes[item]) {
          tempA += item + '; ';
        }
      });

      result += tempA ? 'Добавлены роли: ' + tempA : '';
      let tempB = '';

      Object.keys(newAttributes).forEach((item, index) => {
        if ((item == 'isCustomer' || item == 'isTest' || item == 'isManager') && newAttributes[item] != oldAttributes[item] && !newAttributes[item]) {
          tempB += item + '; ';
        }
      });

      result += tempB ? 'Удалены роли: ' + tempB : '';
      console.warn(tempA, tempB);

      return result;
    },

    getBasicBaseData() {
      if (localStorage.getItem('username') == null || !localStorage.getItem('fullname') == null || !localStorage.getItem('email') == null) {
        Auth.actions.logout();
        return false;
      }
      let result = { username: localStorage.getItem('username'), fullname: localStorage.getItem('fullname'), email: localStorage.getItem('email'), phone: localStorage.getItem('phone') };
      //console.debug(result);
      return result;
    },
  }
};

export default Logging;


// WEBPACK FOOTER //
// ./src/store/modules/logging.js